<template>
  <v-card rounded="lg" outlined class="pa-1">
    <v-card-title class="text-h6 font-weight-medium py-4">
      <v-icon left color="primary">mdi-bullseye-arrow</v-icon>
      Metas ({{ modality_name }})
    </v-card-title>
    <v-card-text class="pb-1 pt-0">
      <v-row justify="center" align='center' style="width: 100%">
        <v-col v-for="(item, idx) in items" :key="`cardBalance-${idx}`" class="pa-1" cols="12" sm="6" lg="4">
          <v-card outlined style="border-radius: 8px;" class="ma-1"
            :color="item.conditional ? (return_eval(item.conditional.expression) > 0 ? 'green lighten-3' : 'red lighten-3') : item.color + ' lighten-3'">
            <div :class="['caption', item.color + '--text text--darken-4 ml-2']">{{ item.description }}</div>
            <div v-if="report[item.key] != null" :class="`${item.color}--text text--darken-4 display-1  ml-2`">
              <span class='display-1 font-weight-bold'>{{ Math.round(Number(report[item.key]) || 0).toLocaleString('pt-BR')+ item.unit }}</span>
              <span class='subheading' v-if='item.key2'> de {{report[item.key2].toLocaleString('pt-BR') + item.unit2}} </span>
              <span v-if='item.conditional' :class="['subheading', return_eval(item.conditional.expression) > 0 ? 'font-weight-bold green--text text--darken-4' : 'font-weight-bold red--text text--darken-4']">
                <v-icon class="ma-0 pa-0" :color="return_eval(item.conditional.expression) < 0 ? 'red darken-3' : 'green darken-3'">
                  {{ return_eval(item.conditional.expression) > 0 ? 'mdi-menu-up' : 'mdi-menu-down'}}
                </v-icon>
                ({{ Number(return_eval(item.conditional.expression)).toLocaleString('pt-BR')}}{{ item.conditional.unit ? item.conditional.unit : ""}})
              </span>
            </div>
            <div v-if="report[item.key] == null" :class="`${item.color}--text text--lighten-4 display-1 ml-2`">**,**</div>
            <v-progress-linear v-if="report[item.key] != null"
              :value='item.progress ? Math.round(Number(report[item.key])) : 100' height="15" rounded
              :color="`${item.color}  darken-2`">
            </v-progress-linear>
            <v-progress-linear v-if="report[item.key] == null" :color="`${item.color} darken-4 mr-3`" indeterminate
              rounded height="6">
            </v-progress-linear>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: 'HeaderDisplay',
  props: {
    report: {
      type: Object,
    },
    modality_name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      items: [
        { key2: 'working_days', unit2: " dias", key: "elapsed_percentage", progress: true, amount: null, icon: "", color: "purple", unit: " %", description: "Dias úteis corridos" },
        { key2: 'month_goal', unit2: "", key: "month_goal_percentage", progress: true, amount: null, icon: "", color: "orange", unit: " %", description: "Meta mensal" },
        { key2: '', unit2: "", key: "total_accumulated", progress: false, conditional: { expression: "(Number(this.report.total_accumulated_percentage_by_accumulated_goal).toFixed(2))", unit: "%" }, amount: null, icon: "", color: "blue", unit: "", description: "Venda real acumulado" },
        // { key2: '', unit2: "", key: "tendency", progress: false, conditional: { expression: "(((this.report.tendency/this.report.month_goal) * 100 - 100) || 0).toFixed(2)", unit: "%" }, amount: null, icon: "", color: "purple", unit: "", description: "Venda tendência acumulado" },
      ],
    }
  },
  methods: {
    calcTendency() {
      if (this.report && this.report.sellers) {
        let total_bags = this.report.sellers.reduce((acc, one) => acc + one.current_accumulated_bags, 0)
        let mean = total_bags / Number(this.report.elapsed_days)
        return total_bags + (this.report.working_days - this.report.elapsed_days) * mean
      }
    },
    setupTendency() {
      this.report.tendency = this.calcTendency()
    },
    return_eval(expression) {
      return eval('(' + expression + ')')
    }
  },
  mounted() {
    this.setupTendency()
  },
  watch: {
    report(nv, ov) {
      if (nv) {
        this.setupTendency()
      }
    }
  },

}
</script>
